package com.havn.app.core.supabase

import kotlinx.browser.window

actual val havnAuthRedirectScheme: String
    get() = window.location.protocol.removeSuffix(":").ifBlank { "https" }

actual val havnAuthRedirectHost: String
    get() = window.location.host.ifBlank { "app.havnre.app" }
